// @ts-strict-ignore
import * as React from 'react';

import {isScdProperty, Property} from 'common/query-builder/query-block/properties-menu/types';

import {Offset} from '../offset';

/**
 * This is for aggregate by SCD property
 * the offset shifts the time series to right by the specified amount
 */
export function SCDOffsetBlock(props: {property: Property; onChange: (property: Property) => void}) {
  if (!isScdProperty(props.property)) {
    return null;
  }
  if (!props.property.scdOffset) {
    return null;
  }
  return (
    <Offset
      value={props.property.scdOffset}
      onChange={(offset) => {
        props.onChange({
          ...props.property,
          scdOffset: offset,
        });
      }}
    />
  );
}
